import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=56dfbf7d&scoped=true&"
import script from "./Pickup.vue?vue&type=script&lang=js&"
export * from "./Pickup.vue?vue&type=script&lang=js&"
import style0 from "./Pickup.vue?vue&type=style&index=0&id=56dfbf7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dfbf7d",
  null
  
)

export default component.exports